{
  "newChat": "New chat",
  "sessions": {
    "search": "Search chats…",
    "empty": "No conversations yet. Start one with “New chat”.",
    "noMatches": "No chats match “{{query}}”.",
    "untitled": "Untitled chat",
    "replying": "Assistant is replying",
    "unread": "New reply",
    "actions": "Conversation actions",
    "rename": "Rename",
    "renameLabel": "Conversation title",
    "clickToRename": "Click to rename",
    "pin": "Pin",
    "unpin": "Unpin",
    "delete": "Delete chat",
    "deleteTitle": "Delete this conversation?",
    "deleteDescription": "“{{title}}” and its messages will be removed. Run logs stay available to administrators.",
    "deleted": "Conversation deleted",
    "groups": {
      "pinned": "Pinned",
      "today": "Today",
      "yesterday": "Yesterday",
      "week": "Previous 7 days",
      "month": "Previous 30 days",
      "older": "Older"
    }
  },
  "conversation": {
    "title": "Conversation",
    "label": "Conversation",
    "scrollToEnd": "Scroll to latest message",
    "emptySession": "Send a message to start the conversation."
  },
  "newChatPage": {
    "greeting": {
      "morning": "Good morning, {{name}}",
      "afternoon": "Good afternoon, {{name}}",
      "evening": "Good evening, {{name}}",
      "night": "Working late, {{name}}?"
    },
    "subtitle": "Ask anything — attach files, images or documents for context.",
    "placeholder": "Message {{agent}}…",
    "agents": "Or pick another assistant",
    "noAgents": "No assistants available",
    "noAgentsHint": "There are no agents you can chat with yet. Ask an administrator to enable one for chat.",
    "createAgent": "Create an agent"
  },
  "agentPicker": {
    "label": "Assistant",
    "placeholder": "Choose an assistant"
  },
  "composer": {
    "label": "Message",
    "placeholder": "Send a message…",
    "send": "Send",
    "stop": "Stop generating",
    "attach": "Attach files",
    "attachHint": "Attach files (or paste / drop them)",
    "hint": "Enter to send · Shift+Enter for a new line · / to focus",
    "uploading": "Uploading… {{percent}}%",
    "uploadFailed": "Upload failed",
    "removeAttachment": "Remove {{name}}",
    "waitForUploads": "Waiting for uploads…",
    "tooManyFiles": "You can attach at most {{count}} files per message.",
    "unsupportedFile": "Not supported: {{names}}",
    "dropHere": "Drop files to attach",
    "dropHint": "Images, PDFs, Office documents, text and code"
  },
  "reasoning": {
    "label": "Reasoning",
    "thinking": "Thinking…",
    "thoughtFor_one": "Thought for {{count}} second",
    "thoughtFor_other": "Thought for {{count}} seconds"
  },
  "phase": {
    "waiting": "Thinking…",
    "tool": "Using {{name}}…",
    "skill": "Loading skill {{name}}…",
    "mcp": "Connecting to {{name}}…"
  },
  "activity": {
    "kind": {
      "tool": "Tool call",
      "skill": "Skill",
      "mcp": "Integration"
    },
    "verb": {
      "tool": "Used",
      "skill": "Loaded",
      "mcp": "Connected"
    },
    "running": "Running",
    "completed": "Completed",
    "failed": "Failed",
    "input": "Input",
    "response": "Response",
    "error": "Error",
    "noInput": "No input for this call.",
    "noResponse": "No response recorded for this call.",
    "waiting": "Waiting for the response…"
  },
  "message": {
    "copy": "Copy",
    "retry": "Retry",
    "failed": "The assistant couldn't finish this reply.",
    "stopped": "Stopped.",
    "paused": "Paused — waiting for human input.",
    "tokensTotal": "Input and output tokens for this reply",
    "usageDetail": "{{input}} in · {{output}} out · {{cached}} cached",
    "tokens": "{{formatted}} tokens"
  },
  "export": {
    "copy": "Copy as Markdown",
    "download": "Download Markdown",
    "copied": "Conversation copied as Markdown",
    "user": "You",
    "attachments": "Attachments"
  },
  "info": {
    "title": "Conversation details",
    "turns": "Turns",
    "created": "Started",
    "updated": "Last activity",
    "contextId": "Context ID",
    "compression": "Context compression",
    "compressionHint": "Folds older turns into a rolling summary so long conversations stay within the model's context.",
    "compressNow": "Compress now",
    "compressed": "Summary updated",
    "summary": "Rolling summary",
    "noSummary": "No summary yet. It is written after a few turns when compression is on.",
    "facts": "Session facts",
    "noFacts": "No facts recorded yet."
  },
  "history": {
    "title": "Chat history",
    "description": "All your conversations. Search by title, assistant or model.",
    "allAgents": "All assistants",
    "summarized": "Summarized",
    "compressionOn": "Compression on",
    "compressionOff": "Off",
    "emptyTitle": "No conversations yet",
    "emptyDescription": "Your chats with assistants will show up here.",
    "columns": {
      "title": "Title",
      "agent": "Assistant",
      "turns": "Turns",
      "memory": "Memory",
      "updated": "Last activity",
      "created": "Started"
    }
  },
  "playground": {
    "title": "Playground",
    "description": "Try prompts and settings without changing the agent.",
    "compare": "Compare",
    "compareHint": "Run the same message against two configurations side by side",
    "pane": "Configuration {{pane}}",
    "settings": "Settings",
    "settingsFor": "Settings — {{pane}}",
    "settingsHint": "Overrides apply to messages sent from the playground only. Unchanged settings use the agent's configuration.",
    "changed": "Changed from the agent's configuration",
    "reset": "Reset",
    "resetAll": "Reset all",
    "save": "Save to agent",
    "saveTitle": "Update {{agent}}?",
    "saveDescription_one": "The changed setting becomes part of the agent's configuration (a new revision is recorded).",
    "saveDescription_other": "The {{count}} changed settings become part of the agent's configuration (a new revision is recorded).",
    "revisionNote": "Saved from the playground",
    "clear": "New conversation",
    "removePane": "Remove this configuration",
    "placeholder": "Send a test message…",
    "placeholderCompare": "Send the same message to both configurations…",
    "empty": "Send a message to try this configuration.",
    "sessionTitle": "Playground · {{agent}} ({{pane}})",
    "providerDefault": "Default",
    "noMcp": "No MCP servers configured.",
    "noSkills": "No skills available.",
    "fields": {
      "model": "Model",
      "systemPrompt": "System prompt",
      "temperature": "Temperature",
      "topP": "Top P",
      "topK": "Top K",
      "thinking": "Model thinking",
      "cacheStatic": "Cache: instructions",
      "cacheMessages": "Cache: conversation",
      "mcp": "MCP servers",
      "skills": "Skills"
    },
    "hints": {
      "temperature": "Lower is more focused and deterministic, higher is more creative.",
      "thinking": "Let models that support it reason before answering.",
      "cache": "Prompt caching (Anthropic models): how long cached instructions and conversation stay warm."
    },
    "cache": {
      "5m": "5 minutes",
      "1h": "1 hour",
      "off": "Off"
    }
  },
  "automations": {
    "title": "Automations",
    "new": "New automation",
    "newTitle": "New automation",
    "search": "Search automations…",
    "noMatches": "No automations match your search.",
    "emptyList": "No automations yet.",
    "emptyTitle": "Automate a recurring task",
    "selectTitle": "Select an automation",
    "emptyDescription": "An automation is a reusable prompt with parameters. Run it here, from a schedule or through its webhook.",
    "notFound": "This automation no longer exists.",
    "back": "Back to automations",
    "api": "API",
    "paramCount_one": "{{count}} parameter",
    "paramCount_other": "{{count}} parameters",
    "runCount_one": "{{count}} run",
    "runCount_other": "{{count}} runs",
    "lastRun": "Last run",
    "create": "Create automation",
    "created": "Automation “{{name}}” created",
    "saved": "Automation “{{name}}” saved",
    "deleted": "Automation “{{name}}” deleted",
    "delete": "Delete",
    "deleteTitle": "Delete “{{name}}”?",
    "deleteDescription": "Schedules and integrations that call this automation will stop working.",
    "run": "Run",
    "runAgain": "Run again",
    "saveBeforeRun": "Save your changes before running",
    "runTitle": "Run “{{name}}”",
    "runDescription": "Fill in the parameters. {{agent}} runs the automation and the output appears below.",
    "running": "Running… this can take a while for longer tasks.",
    "noParams": "This automation has no parameters.",
    "output": "Output",
    "noOutput": "The run finished without output.",
    "close": "Close",
    "done": "Done",
    "insert": "Insert",
    "fields": {
      "name": "Name",
      "description": "Description",
      "agent": "Agent",
      "agentPlaceholder": "Choose an agent"
    },
    "params": {
      "title": "Parameters",
      "description": "Inputs for each run. Use them in the templates as {{example}}; file parameters are attached to the message.",
      "add": "Add parameter",
      "empty": "No parameters yet — add one to make this automation reusable.",
      "label": "Label",
      "labelPlaceholder": "Customer name",
      "name": "Name",
      "type": "Type",
      "required": "Required",
      "default": "Default",
      "noDefault": "No default",
      "remove": "Remove parameter",
      "fileHint": "Uploaded with each run and attached to the message.",
      "invalidName": "Use letters, digits and underscores, not starting with a digit.",
      "duplicate": "Another parameter already uses this name.",
      "types": {
        "string": "Text",
        "number": "Number",
        "file": "File"
      }
    },
    "templates": {
      "title": "Prompt",
      "description": "What the agent receives on every run.",
      "message": "Message template",
      "messageHint": "Sent as the user message.",
      "messagePlaceholder": "Write a short summary of {{topic}} for {{audience}}.",
      "instructions": "Extra instructions",
      "instructionsHint": "Added to the agent's system prompt for this automation only.",
      "instructionsPlaceholder": "Answer in a formal tone."
    },
    "issues": {
      "unknown": "{{placeholder}} is not a parameter.",
      "file": "File parameter “{{name}}” can't be used inside text.",
      "unterminated": "Unbalanced braces: close every {{open}} with {{close}}.",
      "fix": "Fix the template problems below."
    },
    "apiAccess": {
      "title": "API access",
      "description": "Let other systems start this automation with an HTTP request.",
      "enable": "Enable webhook",
      "enableHint": "A secret is generated when you save; it is shown once.",
      "url": "Webhook URL",
      "example": "Example request",
      "secretSet": "A secret is configured. Rotate it if it may have leaked.",
      "noSecret": "No secret yet.",
      "disableWarning": "Saving disables the webhook and revokes its secret."
    },
    "rotate": "Rotate secret",
    "rotateTitle": "Rotate the webhook secret?",
    "rotateDescription": "The current secret stops working immediately. Update every caller with the new one.",
    "secretTitle": "Webhook secret",
    "secretDescription": "Send it as “Authorization: Bearer <secret>” with each request."
  },
  "endpoints": {
    "title": "Chat endpoints",
    "description": "Give websites and apps a token-protected chat API for one agent — JSON or streaming.",
    "new": "New endpoint",
    "newDescription": "One endpoint per agent. A bearer token is created and shown once.",
    "editDescription": "Change how this endpoint behaves. The token stays the same unless you rotate it.",
    "create": "Create endpoint",
    "created": "Endpoint “{{name}}” created",
    "saved": "Endpoint “{{name}}” saved",
    "deleted": "Endpoint “{{name}}” deleted",
    "edit": "Edit",
    "delete": "Delete",
    "deleteTitle": "Delete “{{name}}”?",
    "deleteDescription": "Clients using this endpoint will get errors immediately.",
    "rotate": "Rotate token",
    "rotateTitle": "Rotate the token of “{{name}}”?",
    "rotateDescription": "The current token stops working immediately. Update every client with the new one.",
    "toggle": "Enable {{name}}",
    "perMinute_one": "{{count}}/min",
    "perMinute_other": "{{count}}/min",
    "emptyTitle": "No chat endpoints yet",
    "emptyDescription": "Create an endpoint to embed an agent in your own website, app or workflow tool.",
    "tokenTitle": "Token for “{{name}}”",
    "tokenDescription": "Use it as a bearer token. It won't be shown again — rotate it if it gets lost.",
    "done": "Done",
    "stats": {
      "active": "Enabled endpoints",
      "requests": "Requests",
      "lastUsed": "Last request"
    },
    "columns": {
      "enabled": "On",
      "name": "Name",
      "token": "Token prefix",
      "behaviour": "Behaviour",
      "rateLimit": "Rate limit",
      "uses": "Requests",
      "lastUsed": "Last used"
    },
    "badges": {
      "continuity": "Memory",
      "reasoning": "Reasoning",
      "tools": "Tool calls"
    },
    "fields": {
      "agent": "Agent",
      "agentHint": "Agents that already have an endpoint are not listed.",
      "agentPlaceholder": "Choose an agent",
      "name": "Name",
      "enabled": "Enabled",
      "enabledHint": "Disabled endpoints reject every request.",
      "continuity": "Conversation memory",
      "continuityHint": "Clients may send a context_id to continue an earlier conversation.",
      "reasoning": "Expose reasoning",
      "reasoningHint": "Stream the model's reasoning and intermediate text. Off: clients only see status steps and the final answer.",
      "tools": "Expose tool calls",
      "toolsHint": "Stream tool calls and their results to the client.",
      "rateLimit": "Rate limit",
      "rateLimitHint": "Maximum requests per minute for this endpoint.",
      "perMinuteUnit": "per min"
    },
    "api": {
      "url": "Endpoint URL",
      "json": "JSON response",
      "sse": "Streaming (SSE)",
      "jsonHint": "Returns { output, post, suppress_reason, run_uid, context_id } when the reply is complete. post is false when the agent stayed silent: show nothing.",
      "sseHintFull": "Streams run_started, thinking_delta, text_delta, tool events and a final done event { output, post, suppress_reason }. On text_reset, discard the text shown so far.",
      "sseHintStatus": "Streams status_step updates while the agent works, then text_delta and a final done event { output, post, suppress_reason }. On text_reset, discard the text shown so far."
    }
  }
}
